/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SaveReeferChecklistMutationVariables = Types.Exact<{
  input: Types.CargoInput;
}>;


export type SaveReeferChecklistMutation = {
  __typename?: 'Mutation',
  saveReeferChecklist?: {
    __typename?: 'Cargo',
    id: number,
    voyage?: {
      __typename?: 'Voyage',
      id: number
    } | null
  } | null
};


export const SaveReeferChecklistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveReeferChecklist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveReeferChecklist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SaveReeferChecklistMutation, SaveReeferChecklistMutationVariables>;